import { registerAuthEffects } from '../repositories/auth.effects';
import { setAuthConfig } from '../repositories/auth.actions';
import { AuthConfig } from '../models/auth-config';
import { isDevMode } from '@angular/core';
import { dispatch, initEffects } from '@ngneat/effects';
import { enableElfProdMode } from '@ngneat/elf';
import { EMPTY } from 'rxjs';

/**
 * Internal function that sets the Auth Configuration object and initializes the internal effects.
 */
export const initializeTmxAuth = (authConfig: AuthConfig) => {
  return () => {
    initEffects();
    if (!isDevMode()) {
      enableElfProdMode();
    }
    registerAuthEffects();
    dispatch(setAuthConfig({ authConfig }));
    return EMPTY;
  };
};
